import { cn } from "@hireart/component-library";
import PropTypes from "prop-types";

export const DescriptionTerm = ({ children, className = undefined }) => (
  <dt className={cn("font-semibold", className)}>{children}</dt>
);

DescriptionTerm.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};
